
export enum ProjectType {
  CONSTRUCTION = 'Construção',
  RENOVATION = 'Reforma'
}

export enum ExpenseCategory {
  MATERIALS = 'Materiais',
  LABOR = 'Pessoal / Mão de Obra',
  PROJECTS = 'Projetos',
  DOCUMENTATION = 'Documentação',
  OTHERS = 'Outros'
}

export type UserRole = 'owner' | 'full' | 'photo_only';

export type BudgetMode = 'general' | 'detailed';

export type PlanTier = 'trial' | 'premium' | 'pro_plus';

export interface Stage {
  id: string;
  name: string;
  expectedBudget: number;
  iconName?: string;
}

export interface Expense {
  id: string;
  description: string;
  amount: number;
  date: string; 
  paymentDate: string; 
  isPaid: boolean;
  supplier: string;
  stageId: string;
  installments: number;
  category: ExpenseCategory;
  receiptUrl?: string;
  observations?: string;
}

export interface Photo {
  id: string;
  url: string;
  date: string;
  description: string;
  room: string;
  stageId?: string;
  uploadedBy?: string;
}

export interface Testimonial {
  name: string;
  role: string;
  content: string;
  avatar: string;
}

export interface Project {
  id: string;
  name: string;
  ownerId: string;
  collaborators: string[]; 
  roles?: Record<string, UserRole>;
  type: ProjectType;
  areaSize: number;
  initialBudget: number;
  budgetMode: BudgetMode;
  startDate: string;
  city?: string;
  state?: string;
  shareCode?: string; 
  photoToken?: string; 
  photoTokenExpiresAt?: string; // ISO string para expiração de segurança
  logoUrl?: string;
  stages: Stage[];
  expenses: Expense[];
  photos: Photo[];
}

export interface UserSubscription {
  status: string;
  items: Array<{
    plan: {
      id: string;
      product: string;
      amount: number;
      currency: string;
      interval: string;
    };
  }>;
  current_period_end: {
    seconds: number;
  };
  cancel_at_period_end: boolean;
}
